// extracted by mini-css-extract-plugin
export default {"container":"we-are_container__3jgpG","inner":"we-are_inner__293c_","title":"we-are_title__2flJV","desc":"we-are_desc__1K9l0"};